import { UrlParameter } from './classes';
import { getOptionParameter } from './types/options/options';

export const parameterCollection: Array<UrlParameter> = [];

export const initializeParameterCollection = () => {
  parameterCollection.push(getOptionParameter());
};
